import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { UserService } from '../../shared/services/user.service';
import { MustMatch } from '../../shared/helpers/must-match.helper';
import { User } from '../../shared/interfaces/user.interface';

@Component( {
  selector: 'ngx-app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: [ './register-form.component.scss' ],
} )
export class RegisterFormComponent implements OnInit {

  registerForm: FormGroup;
  loading = false;
  submitted = false;
  error: string;
  apiUrl = environment.apiUrl;
  isLoading = false;
  acceptTerms = false;
  showAlert = false;
  user: User = {};
  provinces = environment.provinces;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toast: ToastrService,
  ) {
    this.createForm();
  }

  get f() {
    return this.registerForm.controls;
  }

  ngOnInit(): void {
  }

  present() {
    this.isLoading = true;
  }

  dismiss() {
    this.isLoading = false;
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.registerForm.valid ) {
      this.userService.register( this.registerForm.value ).subscribe( response => {
        this.user = { ...response.user };
        this.showAlert = true;
        this.registerForm.reset();
        this.submitted = false;
      } );
    }
  }

  private createForm(): void {
    this.registerForm = this.formBuilder.group( {
      name: [ '', Validators.required ],
      lastname: [ '', Validators.required ],
      province: [ '', Validators.required ],
      phone: [ '', [ Validators.required, Validators.pattern( '^-?[0-9]\\d*(\\.\\d{1,2})?$' ) ] ],
      email: [ '', [ Validators.required, Validators.email ] ],
      password: [ '', [ Validators.required, Validators.minLength( 6 ) ] ],
      passwordConfirmation: [ '', Validators.required ],
    }, {
      validator: MustMatch( 'password', 'passwordConfirmation' ),
    } );
  }

}
